module.exports = __webpack_public_path__ + "static/media/004.68860b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/004.jpg
// module id = 511
// module chunks = 0